import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { MaterialModule } from "./material.module";
import { PluginXsExplorerComponent } from "./core/plugins/explorer/xs-explorer/xs-explorer.component";

import { SafePipe } from './common/pipes/safe.pipe';

import { XsBienvenidoComponent } from "./core/plugins/explorer/xs-bienvenido/xs-bienvenido.component";
import { SolicitudRegistroComponent } from "./plusd/plugins/solicitud-registro/solicitud-registro.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FlexLayoutModule } from "@angular/flex-layout";
import { XsLoginComponent } from "./core/plugins/explorer/xs-login/xs-login.component";
import { XsSubLoginComponent } from "./core/plugins/explorer/xs-sub-login/xs-sub-login.component";
import { XsMessageBoxComponent } from "./common/widgets/xs-message-box/xs-message-box.component";
import { TreeviewWidgetComponent } from "./plusd/widgets/treeview-widget/treeview-widget.component";
import { DatatableWidgetComponent } from "./plusd/widgets/datatable-widget/datatable-widget.component";
import { DigitDecimalNumberDirective } from "./common/widgets/digit-decimal-number.directive";
import { ToUpperCaseDirective } from "./common/widgets/upper-case.directive";
import { CaracterNumericoDirective } from "./common/widgets/caracter-numerico.directive";
import { CaracterNroResolucionDirective } from "./common/widgets/caracter-nro-resolucion.directive";
import { CaracterLetraNumeroDirective } from "./common/widgets/caracter-letra-numerico.directive";
import { CookieService } from 'ngx-cookie-service';
import { NgxMaskModule } from 'ngx-mask';

import { DigitDirective } from "./common/directives/digit.directive";
import { LetraNumeroSimpleDirective } from "./common/directives/letra-numero-simple.directive";

// App
import { ConfiguracionPluginComponent } from './plusd/plugins/configuraciones-plugin/configuracion-plugin.component';
import { SolicitudListadoComponent } from './plusd/plugins/solicitud-listado/solicitud-listado.component';
import { ContactoDetalleComponent } from './plusd/plugins/contacto-detalle/contacto-detalle.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatFormFieldModule, MatSelectModule, MatPaginatorIntl } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReactiveFormsModule } from '@angular/forms';
import { XsPerfilComponent } from "./core/plugins/explorer/xs-perfil/xs-perfil.component";
import { ContactoListadoComponent } from './plusd/plugins/contacto-listado/contacto-listado.component';
import { NumericDirective } from "./common/directives/numeric.directive";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormatoFechaDirective } from "./common/widgets/caracter-fecha";
import { CaracterLetraDirective } from "./common/widgets/caracter-letra";
import { CaracterCorreoDirective } from "./common/widgets/caracter-correo";
import { UsuarioSecundarioListadoComponent } from './plusd/plugins/usuario-secundario-listado/usuario-secundario-listado.component';
import { UsuarioSecundarioDetalleComponent } from './plusd/plugins/usuario-secundario-detalle/usuario-secundario-detalle.component';
import { OpcionUsuarioSecundarioComponent } from './plusd/plugins/opcion-usuario-secundario/opcion-usuario-secundario.component';

//import { ExpedienteVirtualListadoComponent } from './plusd/plugins/expediente-virtual-listado/expediente-virtual-listado.component';
//import { ExpedienteVirtualDetalleComponent } from './plusd/plugins/expediente-virtual-detalle/expediente-virtual-detalle.component';
//import { ExpedienteVirtualAltDetalleComponent } from './plusd/plugins/expediente-virtual-alt-detalle/expediente-virtual-alt-detalle.component';
//import { ExpedienteVirtualAltCorreoDetalleComponent } from './plusd/plugins/expediente-virtual-alt-correo-detalle/expediente-virtual-alt-correo-detalle.component';
import { MatPaginatorEs } from './common/lang/MatPaginatorEs';
import { MensajeComponent } from './plusd/plugins/mensaje/mensaje.component';
import { JwtHelperInit } from 'src/app/common/helpers/JwtHelperInit';

import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { XsComunicadoComponent } from './core/plugins/explorer/xs-comunicado/xs-comunicado.component';
import { MpvIframeComponent } from './plusd/plugins/mpv-iframe/mpv-iframe.component';
// import { NgxLocalStorageModule } from 'ngx-localstorage';

@NgModule({
  declarations: [
    SafePipe,
    NumericDirective,
    AppComponent,
    PluginXsExplorerComponent,
    XsLoginComponent,
    XsSubLoginComponent,
    XsMessageBoxComponent,
    TreeviewWidgetComponent,
    DatatableWidgetComponent,
    DigitDecimalNumberDirective,
    CaracterNroResolucionDirective,
    CaracterLetraNumeroDirective,
    FormatoFechaDirective,
    CaracterLetraDirective,
    CaracterCorreoDirective,
    ToUpperCaseDirective,
    CaracterNumericoDirective,
    DigitDirective,
    LetraNumeroSimpleDirective,
    // App
    ConfiguracionPluginComponent,
    SolicitudRegistroComponent,
    SolicitudListadoComponent,
    XsBienvenidoComponent,
    ContactoDetalleComponent,
    ContactoListadoComponent,
    XsPerfilComponent,
    UsuarioSecundarioListadoComponent,
    UsuarioSecundarioDetalleComponent,
    OpcionUsuarioSecundarioComponent,
   
    MensajeComponent,
    XsComunicadoComponent,
    MpvIframeComponent
  ],
  imports: [BrowserModule, MaterialModule, BrowserAnimationsModule, FlexLayoutModule, NgxPaginationModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule, NgxMaskModule.forRoot(),
    RecaptchaModule,
    RecaptchaFormsModule,
    // NgxLocalStorageModule.forRoot(),
  ],
  providers: [
    JwtHelperInit,
    { provide: "BASE_URL", useFactory: getBaseUrl },
    CookieService,
    { provide: MAT_DATE_LOCALE, useValue: 'es' },
    XsBienvenidoComponent,
    { provide: MatPaginatorIntl, useClass: MatPaginatorEs },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'es-419',
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6Ld2Y6YZAAAAAJVEAmNXnKsmnGPcHKQP881r2D5q' } as RecaptchaSettings,
    },
  ],
  entryComponents: [
    XsLoginComponent,
    XsSubLoginComponent,
    XsMessageBoxComponent,
    SolicitudRegistroComponent,
    ContactoDetalleComponent,
    XsPerfilComponent,
    UsuarioSecundarioDetalleComponent,
    OpcionUsuarioSecundarioComponent,
   
    XsComunicadoComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}
